var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.loading
        ? _c("div", { staticClass: "flex-column flex-around-center" }, [
            _c("h2", { staticClass: "text-center" }, [
              _vm._v("Chargement de la carte ..."),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "loader" }),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.errorMsg
        ? _c("div", { staticClass: "text-center" }, [
            _c("h3", { staticClass: "text-danger" }, [
              _vm._v(_vm._s(_vm.errorMsg)),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.card
        ? _c("UpdateFideliteCard", {
            attrs: { card: _vm.card, client: _vm.client },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }